<template>
  <div>
    <v-col>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="filter_text pl-5">Account:</span>
        </v-col>
        <v-spacer />

        <v-col cols="auto">
          <v-autocomplete
            id="account-name-filter-field"
            full-width
            v-model="account_filter"
            :items="accounts"
            item-text="name"
            item-value="account_id"
            outlined
            dense
            clearable
            @change="
              $emit('build_filter', {
                field: 'account_id',
                value: account_filter,
              })
            "
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pl-5 filter_text">Internal Account:</span>
        </v-col>
        <v-spacer />

        <v-col cols="auto">
          <v-autocomplete
            v-model="internal_filter"
            :items="['True', 'False']"
            outlined
            dense
            clearable
            @change="
              $emit('build_filter', {
                field: 'internal',
                value: internal_filter,
              })
            "
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pl-5 filter_text">Cost Center:</span>
        </v-col>
        <v-spacer />

        <v-col cols="auto">
          <v-text-field
            v-model="cost_center_filter"
            outlined
            clearable
            dense
            @change="
              $emit('build_filter', {
                field: 'cost_center',
                value: cost_center_filter,
              })
            "
            @click:clear="
              $emit('build_filter', {
                field: 'cost_center',
                value: null,
              })
            "
          ></v-text-field>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pl-5 filter_text">SAP:</span>
        </v-col>
        <v-spacer />

        <v-col cols="auto">
          <v-text-field
            v-model="sap_filter"
            outlined
            clearable
            dense
            @change="
              $emit('build_filter', {
                field: 'sap',
                value: sap_filter,
              })
            "
            @click:clear="
              $emit('build_filter', {
                field: 'sap',
                value: null,
              })
            "
          ></v-text-field>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pl-5 filter_text">Custom Filter:</span>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <custom-filter
            @build_filter="
              $emit('build_filter', {
                field: $event.field,
                value: $event.value,
              })
            "
          ></custom-filter>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<script>
import CustomFilter from "@/components/shared/CustomFilter.vue";
import adminApi from "@/api/admin";

export default {
  props: {
    show: Boolean,
  },
  components: {
    CustomFilter,
  },
  data() {
    return {
      accounts: [],
      account_filter: null,
      internal_filter: null,
      cost_center_filter: null,
      sap_filter: null,
    };
  },
  mounted() {
    this.getAccounts();
    this.syncFilters();
  },
  watch: {
    $route() {
      this.syncFilters();
      this.getAccounts();
    },
  },
  methods: {
    getAccounts() {
      adminApi
        .fetch_all_accounts(this.$route.query.active_only)
        .then((response) => {
          this.accounts = response;
        })
        .catch(() => {
          // let interceptor handle error
        });
    },

    syncFilters() {
      // filters list with one item returns a string, cast to array
      let filters = this.$route.query.filters || [];
      this.$route.query.filters =
        typeof filters == "string" ? [filters] : filters;

      var account = "account_id";
      var internal = "internal";
      var cost_center = "cost_center";
      var sap = "sap";

      this.account_filter = null;
      this.internal_filter = null;
      this.cost_center_filter = null;
      this.sap_filter = null;

      this.$route.query.filters.forEach((element) => {
        if (element.startsWith(account)) {
          this.account_filter = element.substring(account.length + 1);
        }
        if (element.startsWith(internal)) {
          this.internal_filter = element.substring(internal.length + 1);
        }
        if (element.startsWith(cost_center)) {
          this.cost_center_filter = element.substring(cost_center.length + 1);
        }
        if (element.startsWith(sap)) {
          this.sap_filter = element.substring(sap.length + 1);
        }
      });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  max-width: 185px;
}
</style>
